import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { isEmpty } from 'lodash';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/messages';
import { translate } from 'containers/services/translate';
import { Container } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export interface UpdateStepRecapProps {
  intl: IntlShape;
  updatedBy: string;
}

const UpdateStepRecap: React.FC<UpdateStepRecapProps> = (
  props,
): JSX.Element => {
  return (
    <Container>
      {featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
        !isEmpty(props.updatedBy) && (
          <section className="jadd-decision-recap-container">
            <div className="jadd-decision-recap">
              <h4 className="decision-recap-container-title">
                {translate(messages.updatedBy, props)}
              </h4>
              &nbsp;
              <h4 className="decision-recap-container-status">
                <span>{props.updatedBy}</span>
              </h4>
            </div>
          </section>
        )}
    </Container>
  );
};

export default injectIntl(UpdateStepRecap);
